(function(){
  window.ksAddToCart = window.ksAddToCart || function(variantId, qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:qty||1}]})})
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        var d=document.querySelector('cart-drawer');
        if(d){ if(typeof d.show==='function'){ d.show(); } else { d.setAttribute('open',''); } }
        else { window.location.href='/cart'; }
      });
  };
  document.addEventListener('click', function(e){
    var b = e.target.closest('.ks-card__button[data-ks-add]');
    if(!b) return;
    e.preventDefault();
    if(b.disabled) return;
    var t = b.textContent; b.disabled = true; b.textContent = 'Adding…';
    window.ksAddToCart(b.getAttribute('data-ks-add'), 1)
      .then(function(){ b.textContent = t; b.disabled = false; })
      .catch(function(){ b.textContent = t; b.disabled = false; window.location.href = '/products/' + (b.closest('.ks-card')||{}).getAttribute('data-product-handle'); });
  });
})();
